import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/home/HowItWorks";
import MeetingFlow from "@/components/home/MeetingFlow";
import AudienceWhy from "@/components/home/AudienceWhy";
import NetworkSlideshow from "@/components/home/NetworkSlideshow";
import SignupSection from "@/components/home/SignupSection";
import StatsBand from "@/components/home/StatsBand";
import QuickLinks from "@/components/QuickLinks";
import Footer from "@/components/Footer";
import { SEOHead } from "@/components/SEO/SEOHead";
import { StructuredData } from "@/components/SEO/StructuredData";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Företagsnätverk online utan medlemskap"
        description="Digitalt affärsnätverk för företagare, säljare och rådgivare. Nätverksträffar online utan medlemskap eller bindningstid, 150 kr per träff. Anmäl dig här."
        type="website"
        keywords={['affärsnätverk', 'onlinenätverk', 'nätverksträffar online', 'företagsnätverk', 'nätverka digitalt', 'NYFIKENmodellen®', 'konsultativ försäljning']}
      />
      <StructuredData
        type="Organization"
        data={{
          name: 'Affärsnätverket',
          url: 'https://affarsnatverket.se',
          logo: 'https://affarsnatverket.se/logo.png',
          description: 'Affärsnätverket arrangerar digitala nätverksträffar för företagare, säljare och rådgivare som vill bygga långsiktiga kundrelationer.',
          address: { addressCountry: 'SE' },
          contactPoint: { contactType: 'Customer Service' },
        }}
      />
      <Navigation />
      <main>
        <Hero />
        <SignupSection />
        <NetworkSlideshow />
        <StatsBand />
        <HowItWorks />
        <MeetingFlow />
        <AudienceWhy />
        <QuickLinks />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
